/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Input kind hint.
 */
export const DeviceIntegrationProviderFieldKind = {
  Text: "text",
  Url: "url",
} as const;
/**
 * Input kind hint.
 */
export type DeviceIntegrationProviderFieldKind = OpenEnum<
  typeof DeviceIntegrationProviderFieldKind
>;

/**
 * One credential or settings input a provider needs to connect. Secret fields are stored encrypted and are write-only; non-secret fields are readable settings.
 */
export type DeviceIntegrationProviderField = {
  /**
   * Field identifier in the credentials or settings document.
   */
  key: string;
  /**
   * Input kind hint.
   */
  kind: DeviceIntegrationProviderFieldKind;
  /**
   * Human-readable name to render for the field.
   */
  label: string;
  /**
   * Whether the field must be supplied to connect the provider.
   */
  required: boolean;
  /**
   * Whether the value is secret: stored encrypted, write-only, and masked in the UI.
   */
  secret: boolean;
};

/** @internal */
export const DeviceIntegrationProviderFieldKind$inboundSchema: z.ZodMiniType<
  DeviceIntegrationProviderFieldKind,
  unknown
> = openEnums.inboundSchema(DeviceIntegrationProviderFieldKind);

/** @internal */
export const DeviceIntegrationProviderField$inboundSchema: z.ZodMiniType<
  DeviceIntegrationProviderField,
  unknown
> = z.object({
  key: z.string(),
  kind: DeviceIntegrationProviderFieldKind$inboundSchema,
  label: z.string(),
  required: z.boolean(),
  secret: z.boolean(),
});

export function deviceIntegrationProviderFieldFromJSON(
  jsonString: string,
): SafeParseResult<DeviceIntegrationProviderField, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeviceIntegrationProviderField$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeviceIntegrationProviderField' from JSON`,
  );
}
